import Vue from "vue";
import Toasted from "vue-toasted";

Vue.use(Toasted, {
  iconPack: "fontawesome",
  className: "ink-toasted",
  containerClass: "ink-toasted__container"
});

const _baseToastObject = {
  position: "top-right",
  duration: 3000
};

// options to the toast
const errorOptions = {
  type: "error",
  icon: "times-circle-o",
  ..._baseToastObject
};

const successOptions = {
  type: "success",
  icon: "check-circle-o",
  ..._baseToastObject
};

const warningOptions = {
    type: "warning",
    icon: "warning",
    ..._baseToastObject
};

// register the toast with the custom message
Vue.toasted.register(
  "error",
  payload => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Something went wrong";
    }

    // if there is a message show it with the message
    return payload.message;
  },

  errorOptions
);

// register the toast with the custom message
Vue.toasted.register(
  "success",
  payload => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Done!";
    }

    // if there is a message show it with the message
    return payload.message;
  },

  successOptions
);

// register the toast with the custom message
Vue.toasted.register(
    "warning",
    payload => {
        // if there is no message passed show default message
        if (!payload.message) {
            return "Warning!";
        }

        // if there is a message show it with the message
        return payload.message;
    },

    warningOptions
);